import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-488f6c79"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "animation" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "3D Animation", -1))
const _hoisted_3 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_5 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { isMobile } from "../common/common";

import { defineComponent } from "vue";
import { VideoPlayer } from "@videojs-player/vue";
import "video.js/dist/video-js.css";

const __default__ = defineComponent({
  components: {
    VideoPlayer,
  },
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'VideoPlayers',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/0001 copy.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"40vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"]),
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/bubbles.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"40vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/cloth.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"40vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"]),
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/cuboid.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"40vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/dropit_00001_1.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"40vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"]),
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/WAVEY.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"40vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/DragonFinal2.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"20vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"]),
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/failedDominoes.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"20vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"]),
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/PEGSDAMMiT.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"20vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"]),
      _hoisted_7,
      _createVNode(_unref(VideoPlayer), {
        src: require('../videos/moonsystem_00001.mp4'),
        autoplay: !_unref(isMobile)(),
        loop: "",
        volume: -1,
        style: {"width":"20vw","height":"40vw"}
      }, null, 8, ["src", "autoplay"])
    ])
  ], 64))
}
}

})